import { inject, Injectable, Injector } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { catchError, Observable, switchMap, throwError } from 'rxjs';
import { AuthService } from '../../authentication/services/auth.service';
import { ConfigService } from '../config/config.service';

@Injectable({
  providedIn: 'root'
})
export class InterceptorService implements HttpInterceptor {
  private config = inject(ConfigService);

  unAuth = [
    this.config.apiUrl + '/login',
    this.config.apiUrl + '/governorates',
    this.config.apiUrl + '/Identity/api/Identity/RefreshToken',
    this.config.apiUrl + '/Identity/api/Otp/Send',
    this.config.apiUrl + '/ServiceDesk/api/Requests/ViewFile'
  ];

  constructor(private injector: Injector) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const authService = this.injector.get(AuthService);

    req = req.clone({
      setHeaders: {
        'Accept-Language': localStorage.getItem('lang')
          ? (localStorage.getItem('lang') as string)
          : 'en'
      }
    });

    if (req.headers.has('Bypass-Interceptor')) {
      return next.handle(req);
    }

    const authToken = authService.getUserToken();

    if (!this.unAuth.includes(req.url)) {
      if (authToken) {
        req = this.addToken(req, authToken);
      }
    }

    return next.handle(req).pipe(
      catchError((err) => {
        if (err instanceof HttpErrorResponse) {
          if (err?.status === 401) {
            return this.handle401Error(authService, req, next);
          } else if (
            req.url ==
              this.config.apiUrl + '/Identity/api/Identity/RefreshToken' &&
            err.status != 406
          ) {
            authService.logout().subscribe();
          }
        }

        return throwError(err);
      })
    );
  }

  private addToken(request: HttpRequest<any>, token: string): HttpRequest<any> {
    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
  }

  private handle401Error(
    authService: AuthService,
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const user = authService.user$();

    return authService
      .refreshToken({
        refreshToken: user?.refreshToken,
        accessToken: user?.accessToken
      })
      .pipe(
        switchMap((newAccessToken: any) => {
          if (newAccessToken) {
            if (!this.unAuth.includes(request.url)) {
              request = this.addToken(request, newAccessToken);
            }

            return next.handle(request);
          }

          // If refresh token fails, redirect to login or handle as needed
          return throwError('Session expired, please login again.');
        })
      );
  }
}
